export const faq = [
  {
    q: "Vos formations sont-elles éligibles au CPF ?",
    a: "Oui. YAFORMIS est un organisme de formation déclaré et certifié Qualiopi. Toutes nos formations sont éligibles au CPF, OPCO et plan de développement des compétences de l'entreprise.",
  },
  {
    q: "Faut-il un niveau technique pour suivre vos formations ?",
    a: "Non, pas pour la majorité. L'Initiation IA et la formation Outils IA sont accessibles sans aucun prérequis technique. Seules les formations IA Générative et Agents IA demandent une maîtrise préalable des outils IA de base.",
  },
  {
    q: "Quels sont les formats proposés ?",
    a: "Présentiel (intra-entreprise dans vos locaux ou inter-entreprise dans nos centres) et distanciel synchrone via visio. Le format hybride est également possible. Nous nous adaptons à vos contraintes.",
  },
  {
    q: "Comment se déroule l'inscription ?",
    a: "Vous remplissez le formulaire de contact ou nous appelez. Un conseiller pédagogique vous recontacte sous 24h pour qualifier votre projet, vous envoyer un devis et un programme personnalisé. Inscription confirmée après signature de la convention.",
  },
  {
    q: "Quels résultats concrets puis-je attendre ?",
    a: "Nos stagiaires gagnent en moyenne 8 à 12 heures de productivité par semaine après une formation Outils IA. La formation Agents IA permet de déployer un agent fonctionnel en production. Tous les programmes incluent un projet appliqué à votre métier.",
  },
  {
    q: "Vos formateurs ont-ils une expérience terrain ?",
    a: "Oui. Tous nos formateurs sont des praticiens IA en activité (consultants, ingénieurs, fondateurs) avec un minimum de 5 ans d'expérience. Aucun formateur 'théorique' chez YAFORMIS.",
  },
  {
    q: "Le contenu de la formation est-il personnalisable ?",
    a: "Absolument. Pour les formations intra-entreprise, le programme est adapté à votre secteur, vos outils et vos cas d'usage. Vos données et processus servent de fil rouge pédagogique.",
  },
  {
    q: "Y a-t-il un suivi après la formation ?",
    a: "Oui. Toutes nos formations incluent un accès au support pédagogique pendant 6 mois et 1 session de coaching individuel à 30 jours. La formation Agents IA inclut 1 mois de mentorat technique.",
  },
];
